export default __webpack_public_path__ + "static/media/iconeRequisitosPorEscopoMaior.4fb4e6ab.png";